export default __webpack_public_path__ + "static/media/Alpha_18_x_24.689e262a.jpg";